var exports = {
  "kL": "TextualAttachmentPreviewBottomSheet.module__container___LVJXTW",
  "Hy": "TextualAttachmentPreviewBottomSheet.module__codeContainer___LVJXTW",
  "Dy": "TextualAttachmentPreviewBottomSheet.module__codeSurface___LVJXTW",
  "qr": "TextualAttachmentPreviewBottomSheet.module__footer___LVJXTW",
  "qt": "TextualAttachmentPreviewBottomSheet.module__fileSection___LVJXTW",
  "gM": "TextualAttachmentPreviewBottomSheet.module__fileMeta___LVJXTW",
  "Md": "TextualAttachmentPreviewBottomSheet.module__fileName___LVJXTW",
  "Ov": "TextualAttachmentPreviewBottomSheet.module__fileSize___LVJXTW",
  "zt": "TextualAttachmentPreviewBottomSheet.module__footerActions___LVJXTW",
  "hP": "TextualAttachmentPreviewBottomSheet.module__actionButton___LVJXTW" + " " + __webpack_require__(77126)["AS"],
};

module.exports = exports;
